/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grim_Cold_Shark_SnapInputs */

const en_grim_cold_shark_snap = /** @type {(inputs: Grim_Cold_Shark_SnapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grant access to results failed`)
};

const de_grim_cold_shark_snap = /** @type {(inputs: Grim_Cold_Shark_SnapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebniszugriff freigeben fehlgeschlagen!`)
};

/**
* | output |
* | --- |
* | "Grant access to results failed" |
*
* @param {Grim_Cold_Shark_SnapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const grim_cold_shark_snap = /** @type {((inputs?: Grim_Cold_Shark_SnapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grim_Cold_Shark_SnapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_grim_cold_shark_snap(inputs)
	return de_grim_cold_shark_snap(inputs)
});